import React from "react";

const Context2D = React.createContext();

export default Context2D